/**
 * DriverRequest
 * @author ftgibran
 */
import {$, Model, HttpIgnore, IResource, ResponseFill} from 'simpli-web-sdk'
import * as Helper from '@/helpers'
import {ItrackCollection} from '@/helpers'
import {Transhipment} from '@/enums/Transhipment'

@HttpIgnore()
export default class DriverRequest extends Model {
  readonly $name: string = 'DriverRequest'

  idFilial = Helper.getIdFilial()

  @ResponseFill('transhipment')
  transhipment: Transhipment | null = null

  allTranshipment = ItrackCollection.allTranshipment.prependNull('app.all')

  get transbordoResource() {
    return this.allTranshipment.get(this.transhipment)
  }

  set transbordoResource(val: IResource | null) {
    this.transhipment = val && val.$id as Transhipment || null
  }
}
